import React, { useEffect, useRef, useState } from 'react'
import { Badge, Button, Col, Pagination, Row, Select, Spin, Statistic, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { useLazyFetchallBargainProductQuery, useLazyGetBidderListQuery, useLazyGroupBargainByLevelQuery } from '../../../redux/AuctionApi';
import { AuctionResponse, StartStatus, WebsocketTypes } from '../../../types';
import { format } from 'date-fns';
import { AuctionTypeCode, preCostTypes, registerTypes, SocketMessage } from '../../../../common/types/types';
import { useAppSelector } from '../../../../../redux/Hooks';
import DenyRightsModal from './DenyRightsModal';

interface Identifier {
    active: boolean,
    title: string,
    id: number,
    bidderId: number,
}

interface UserList {
    key: number,
    identifier: Identifier,
    note: string,
    reason: string,
}

interface PriceHistory {
    key: number,
    identifier: Identifier,
    date: string,
    price: JSX.Element,
    level?: number,
}

interface PriceRoundHistory {
    key: number,
    level: number,
    price: JSX.Element,
}

interface AuctionHistoryProps {
    item?: AuctionResponse,
    socketUpdate: boolean,
    setSocketUpdate: React.Dispatch<React.SetStateAction<boolean>>,
    newPayload?: SocketMessage,
}

const { Option } = Select;

const AuctionHistory = ({ item, socketUpdate, setSocketUpdate, newPayload }: AuctionHistoryProps) => {
    const [userPage, setUserPage] = useState(1)
    const [userSize, setUserSize] = useState(10)
    const [userTableData, setUserTableData] = useState<UserList[]>([]);
    const [denyVisible, setDenyVisible] = useState(false);
    const [denyNote, setDenyNote] = useState("");
    const [bidderId, setBidderId] = useState(0);
    const [bidderCode, setBidderCode] = useState("");

    const [historyPage, setHistoryPage] = useState(1);
    const historySize = useRef(10);
    const [historyTableData, setHistoryTableData] = useState<PriceHistory[]>([]);
    const [roundHistoryTableData, setRoundHistoryTableData] = useState<PriceRoundHistory[]>([]);

    const [trigger, response] = useLazyFetchallBargainProductQuery();
    const [groupTrigger, groupResponse] = useLazyGroupBargainByLevelQuery();
    const [bidderTrigger, bidderResponse] = useLazyGetBidderListQuery();

    const auctionState = useAppSelector(state => state.auction);
    const userState = useAppSelector(state => state.login);

    useEffect(() => {
        if (item?.productId) {
            if (item?.statute?.auctionType?.code === AuctionTypeCode.HAVE_ROUND && item?.startStatus === StartStatus.ONGOING) {
                let levels = auctionState.level > 1 ? Array.from(Array(auctionState.level - 1), (x, i) => (i + 1)) : [0];
                groupTrigger({ productId: item.productId, lstLevel: levels, page: historyPage - 1, size: historySize.current }).unwrap().then(() => {
                    setSocketUpdate(false);
                })
            } else if (item.statute.statuteId) {
                trigger({ page: historyPage - 1, size: historySize.current, productId: item.productId, statuteId: item.statute.statuteId }).unwrap()
                    .then(() => {
                        setSocketUpdate(false)
                    });
            }

        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socketUpdate, auctionState, item])

    useEffect(() => {
        if (item?.productId && item.statute.statuteId && item.startStatus !== StartStatus.UPCOMING) {
            bidderTrigger({ size: 10, page: 0, productId: item.productId, statuteId: item.statute.statuteId, preCostStatus: preCostTypes.DONE, registerStatus: registerTypes.SUCCESS });
        }
    }, [bidderTrigger, item?.productId, item?.startStatus, item?.statute.statuteId])

    useEffect(() => {
        if (response.data?.content) {
            let historyData: PriceHistory[] = response.data.content.map((item, index) => {
                return {
                    key: index,
                    identifier: {
                        active: item.bidder?.onlineStatus || false,
                        title: item.bidder?.identityCode || "",
                        id: item.user.userId || 0,
                        bidderId: item.bidder?.bidderId || 0,
                    },
                    date: format(item.modifiedDate, "dd/MM/yyyy HH:mm:ss"),
                    price: <Statistic
                        value={item.valueOfBid || 0}
                        groupSeparator='.'
                        decimalSeparator=','
                        precision={0}
                        valueStyle={{ fontSize: 14, fontFamily: 'Quicksand' }} />,
                    ...item.level ? { level: item.level } : {},
                }
            })

            setHistoryTableData([...historyData]);
        }
    }, [response])

    useEffect(() => {
        if (bidderResponse.data?.content) {
            // console.log(bidderResponse);
            let bidderData: UserList[] = [];
            bidderData = bidderResponse.data?.content?.map((bidderItem, index) => {
                return {
                    key: index,
                    identifier: {
                        active: bidderItem.onlineStatus || false,
                        title: bidderItem.identityCode || "",
                        id: bidderItem.user.userId || 0,
                        bidderId: bidderItem.bidderId || 0,
                    },
                    note: bidderItem.noteDetect || "",
                    reason: bidderItem.note || "",
                }
            })

            console.log(bidderData);
            setUserTableData(bidderData);
        }
    }, [bidderResponse, item?.startStatus])

    useEffect(() => {
        if (groupResponse.data) {
            let roundData: PriceRoundHistory[] = [];
            roundData = groupResponse.data?.content?.map((item, index) => {
                return {
                    key: index,
                    level: item.level,
                    price: <Statistic
                        value={item.valueOfBid || 0}
                        groupSeparator='.'
                        decimalSeparator=','
                        precision={0}
                        valueStyle={{ fontSize: 14, fontFamily: 'Quicksand' }} />
                }
            })

            setRoundHistoryTableData(roundData);
        }
    }, [groupResponse])

    useEffect(() => {
        // Cập nhật trạng thái online cho người dùng tham gia đấu giá
        if ((newPayload?.type === WebsocketTypes.ONLINE || newPayload?.type === WebsocketTypes.OFFLINE)
            && item?.startStatus === StartStatus.ONGOING
            && socketUpdate) {
            // console.log(newPayload);
            // console.log(userTableData);
            let userTableIndex = userTableData.findIndex(item => item.identifier.id === newPayload?.userId);
            // console.log(userTableIndex);
            if (userTableIndex >= 0) {
                let newData = [...userTableData];
                newData[userTableIndex].identifier.active = newPayload?.type === WebsocketTypes.ONLINE ? true : false;
                setUserTableData(newData);
            }

            let newHistoryTableData = [...historyTableData];
            historyTableData.forEach((item, index) => {
                if (item.identifier.id === newPayload?.userId) {
                    newHistoryTableData[index].identifier.active = newPayload?.type === WebsocketTypes.ONLINE ? true : false;
                }
            })
            setHistoryTableData(newHistoryTableData);
            setSocketUpdate(false);
        } else if (
            (newPayload?.type === WebsocketTypes.IS_LATE ||
                newPayload?.type === WebsocketTypes.DGV_TRUAT_QUYEN || newPayload?.type === WebsocketTypes.RUT_LAI_GIA ||
                newPayload?.type === WebsocketTypes.TRUAT_QUYEN || newPayload?.type === WebsocketTypes.TU_CHOI_GIA_TRUNG) &&
            socketUpdate
        ) { // Cập thật trạng thái vào muộn hoặc bị đấu giá viên truất quyền
            // let userTableIndex = userTableData.findIndex(item => item.identifier.id === newPayload?.userId);
            // if (userTableIndex >= 0) {
            //     let newData = [...userTableData];
            //     if (newPayload?.type === WebsocketTypes.IS_LATE) {
            //         newData[userTableIndex].note = (newPayload?.message || "Người dùng vào muộn");
            //     } else {
            //         newData[userTableIndex].note = "ĐGV truất quyền";
            //     }
            //     console.log(newData[userTableIndex]);
            //     setUserTableData(newData);
            // }
            if (item?.productId && item?.statute.statuteId) {
                bidderTrigger({ size: userSize, page: userPage - 1, productId: item.productId, statuteId: item.statute.statuteId, preCostStatus: preCostTypes.DONE, registerStatus: registerTypes.SUCCESS });;
            }
        }
    }, [historyTableData, newPayload?.type, newPayload?.userId, setSocketUpdate, socketUpdate,
        userTableData, newPayload, item?.productId, item?.statute.statuteId, bidderTrigger, userSize, userPage])

    const userListColumns: ColumnsType<UserList> = [
        {
            title: 'STT',
            dataIndex: 'stt',
            width: '20%',
            align: 'center',
            key: 'index',
            render: (value, record, index) => {
                return (<span
                    style={{ background: '#F1EFEA', padding: '7px 13px', borderRadius: '20px', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                    key={index}>
                    {(userPage - 1) * userSize + index + 1}
                </span>)
            }
        },
        {
            title: 'Mã định danh',
            dataIndex: 'identifier',
            key: 'identifier',
            width: '25%',
            render: (identifier: Identifier) => {
                return <div style={{ display: 'flex' }} key={identifier.title}>
                    {item?.startStatus === StartStatus.ONGOING ?
                        <span><Badge color={identifier.active ? "#97BC2D" : '#A9A59C'} /></span>
                        : <></>}
                    {identifier.id === userState.user.userId ?
                        <span style={{ fontWeight: 'bold' }}>{identifier.title + " (Bạn)"}</span>
                        : <span>{identifier.title}</span>}
                </div>
            }
        },
        {
            title: 'Ghi chú',
            dataIndex: 'note',
            key: 'note',
        }
        ,
        {
            dataIndex: 'action',
            key: 'action',
            title: 'Lý do',
            render: (value, record) => {
                if (record.reason) {
                    return (
                        <Button
                            onClick={() => openDenyModal(record.reason, record.identifier.bidderId, record.identifier.title)}
                            className="button-light-yellow"
                            style={{ fontSize: 14 }}>Xem lý do</Button>
                    )
                }

                return <></>;
            }
        },
    ];

    const priceHistoryColumns: ColumnsType<PriceHistory> = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: '20%',
            align: 'center',
            render: (value, record, index) => {
                return (<span
                    style={{ background: '#F1EFEA', padding: '7px 13px', borderRadius: '20px', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                    key={index}>
                    {(historyPage - 1) * historySize.current + index + 1}
                </span>)
            }
        },
        {
            title: 'Mã định danh',
            dataIndex: 'identifier',
            key: 'identifier',
            width: '25%',
            render: (identifier: Identifier) => {
                return <div style={{ display: 'flex' }} key={identifier.title}>
                    {item?.startStatus === StartStatus.ONGOING ?
                        <span><Badge color={identifier.active ? "#97BC2D" : '#A9A59C'} /></span>
                        : <></>}
                    {identifier.id === userState.user.userId ?
                        <span style={{ fontWeight: 'bold' }}>{identifier.title + " (Bạn)"}</span>
                        : <span>{identifier.title}</span>}
                </div>
            }
        },
        {
            title: item?.statute?.auctionType?.code === AuctionTypeCode.HAVE_ROUND ? 'Vòng trả giá' : 'Thời gian',
            dataIndex: 'date',
            key: 'date',
            render: (value, record) => {
                if (item?.statute?.auctionType?.code === AuctionTypeCode.HAVE_ROUND) {
                    return (
                        <div>{`Vòng ${record.level} - ${value}`}</div>
                    )
                }

                return value;
            }
        },
        {
            title: 'Trả giá',
            dataIndex: 'price',
            key: 'price',
        },
    ]

    const priceRoundHistoryColumns: ColumnsType<PriceRoundHistory> = [
        {
            title: 'STT',
            dataIndex: 'stt',
            key: 'stt',
            width: '20%',
            align: 'center',
            render: (value, record, index) => {
                return (<span
                    style={{ background: '#F1EFEA', padding: '7px 13px', borderRadius: '20px', fontWeight: 'bold', whiteSpace: 'nowrap' }}
                    key={index}>
                    {(historyPage - 1) * historySize.current + index + 1}
                </span>)
            }
        },
        {
            title: 'Vòng trả giá',
            dataIndex: 'level',
            key: 'level',
            width: '25%',
            render: (value: number) => (<div>{`Vòng ${value}`}</div>)
        },
        {
            title: 'Trả giá',
            dataIndex: 'price',
            key: 'price',
        },
    ]

    const searchHistory = (currentPage: number, currentSize: number) => {
        if (item?.statute?.auctionType?.code === AuctionTypeCode.HAVE_ROUND && item?.startStatus === StartStatus.ONGOING) {
            let levels = auctionState.level ? Array.from(Array(auctionState.level - 1), (x, i) => (i + 1)) : [0];
            groupTrigger({ productId: item?.productId || 0, lstLevel: levels, page: currentPage - 1, size: currentSize });
        } else {
            trigger({ page: currentPage - 1, size: currentSize, productId: item?.productId || 0, statuteId: item?.statute?.statuteId || 0 })
        }
    }

    const onUserPageChange = (currentPage: number) => {
        setUserPage(currentPage);
        if (item) {
            bidderTrigger({
                size: userSize,
                page: currentPage - 1,
                productId: item.productId,
                statuteId: item.statute.statuteId,
                preCostStatus: preCostTypes.DONE,
                registerStatus: registerTypes.SUCCESS
            });
        }
    }

    const onUserSizeChange = (currentSize: number) => {
        setUserPage(1);
        setUserSize(currentSize);
        if (item) {
            bidderTrigger({
                size: currentSize,
                page: 0,
                productId: item?.productId,
                statuteId: item.statute.statuteId,
                preCostStatus: preCostTypes.DONE,
                registerStatus: registerTypes.SUCCESS
            });
        }
    }

    const onHistorySizeChange = (currentSize: number) => {
        historySize.current = currentSize;
        searchHistory(1, currentSize);
        setHistoryPage(1)
    }

    const onHistoryPageChange = (currentPage: number) => {
        setHistoryPage(currentPage);
        searchHistory(currentPage, historySize.current);
    }

    const openDenyModal = (note: string, bidderId: number, bidderCode: string) => {
        setDenyNote(note);
        setBidderId(bidderId);
        setBidderCode(bidderCode);
        setDenyVisible(true);
    }

    const closeDenyModal = () => {
        setDenyVisible(false);
        setDenyNote("");
        setBidderCode("");
        setBidderId(0);
    }

    return (
        <div>
            <Row gutter={25}>
                <Col sm={24} md={12}>
                    <h2>Người tham gia đấu giá</h2>
                    <span style={{ background: '#E59F17', padding: '5px 15px', borderRadius: '5px', color: 'white', marginRight: '5px', fontWeight: 'bold' }}>
                        {bidderResponse.data?.totalElements || 0}
                    </span>
                    <span>người tham gia đấu giá</span>
                    <div style={{ marginTop: '20px', position: 'relative' }}>
                        <Table
                            rowKey="key"
                            style={{ maxHeight: 500, overflow: 'auto' }}
                            columns={userListColumns}
                            dataSource={userTableData}
                            pagination={false}
                        />
                        <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Select className="left-arrow-select" defaultValue={10} value={userSize} onChange={onUserSizeChange} dropdownStyle={{ borderRadius: 15 }}>
                                <Option value={10}>10</Option>
                                <Option value={20}>20</Option>
                                <Option value={50}>50</Option>
                                <Option value={100}>100</Option>
                            </Select>
                            <div style={{ marginRight: 20, marginLeft: 8, fontSize: 14 }}>Bản ghi</div>
                            <Pagination
                                total={bidderResponse.data?.totalElements || 0}
                                defaultCurrent={1}
                                defaultPageSize={10}
                                current={userPage}
                                pageSize={userSize}
                                onChange={onUserPageChange}
                                className="custom-pagination"
                                showSizeChanger={false}
                            />
                        </div>
                    </div>
                </Col>
                <Col sm={24} md={12}>
                    {item?.statute.auctionType?.code === AuctionTypeCode.HAVE_ROUND && item?.startStatus === StartStatus.ONGOING ?
                        <></> :
                        <>
                            <h2>Lịch sử đấu giá</h2>
                            <span style={{ background: '#E59F17', padding: '5px 15px', borderRadius: '5px', color: 'white', marginRight: '5px', fontWeight: 'bold' }}>
                                {response.data?.totalElements || 0}
                            </span>
                            <span>lượt trả giá</span>
                        </>}
                    <div style={{ marginTop: '20px', position: 'relative' }}>
                        <Spin spinning={response.isLoading}>
                            {item?.statute.auctionType?.code === AuctionTypeCode.HAVE_ROUND && item?.startStatus === StartStatus.ONGOING ?
                                <Table
                                    rowKey="key"
                                    style={{ maxHeight: 500, overflow: 'auto' }}
                                    columns={priceRoundHistoryColumns}
                                    dataSource={roundHistoryTableData}
                                    pagination={false}
                                /> :
                                <Table
                                    rowKey="key"
                                    style={{ maxHeight: 500, overflow: 'auto' }}
                                    columns={priceHistoryColumns}
                                    dataSource={historyTableData}
                                    pagination={false}
                                />}
                            <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                                <Select className="left-arrow-select" defaultValue={10} value={historySize.current} onChange={onHistorySizeChange} dropdownStyle={{ borderRadius: 15 }}>
                                    <Option value={10}>10</Option>
                                    <Option value={20}>20</Option>
                                    <Option value={50}>50</Option>
                                    <Option value={100}>100</Option>
                                </Select>
                                <div style={{ marginRight: 20, marginLeft: 8, fontSize: 14 }}>Bản ghi</div>
                                {item?.statute.auctionType?.code === AuctionTypeCode.HAVE_ROUND && item?.startStatus === StartStatus.ONGOING ?
                                    <Pagination
                                        total={groupResponse.data?.totalElements || 0}
                                        defaultCurrent={1}
                                        defaultPageSize={10}
                                        current={historyPage}
                                        pageSize={historySize.current}
                                        onChange={onHistoryPageChange}
                                        className="custom-pagination"
                                        showSizeChanger={false}
                                    /> :
                                    <Pagination
                                        total={response.data?.totalElements || 0}
                                        defaultCurrent={1}
                                        defaultPageSize={10}
                                        current={historyPage}
                                        pageSize={historySize.current}
                                        onChange={onHistoryPageChange}
                                        className="custom-pagination"
                                        showSizeChanger={false}
                                    />
                                }
                            </div>
                        </Spin>
                    </div>
                </Col>
            </Row>

            {denyVisible ?
                <DenyRightsModal
                    denyVisible={denyVisible}
                    toggleDenyVisible={closeDenyModal}
                    note={denyNote}
                    bidderId={bidderId}
                    bidderCode={bidderCode}
                    otherUser={true}
                /> : <></>
            }

        </div>
    )
}

export default AuctionHistory